import { Badge, Box, HStack, Menu, MenuButton, MenuItem, MenuList, Portal, Text } from '@chakra-ui/react';
import { GitBranch } from 'lucide-react';
import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { RtaIconButton } from '@components';
import { useDesign } from '@hooks';

export const VersionHistoryControl = (): React.ReactElement => {
	const [controller, design] = useDesign<Controller>();

	// re-render the tree whenever the active version changes
	useSubscription(controller, false, [['kitchen_version', 'updated']]);

	const kitchens = design?.blueprint?.kitchens ?? null;
	const activeId = controller?.kitchen?.id ?? null;

	const loadVersion = (version: number | null): void => {
		if (design?.bpController) design.bpController.kitchenVersion = version;
		if (controller) controller.kitchenVersion = version;
	};

	const rank = (version: number | null): number => version === null ? Number.POSITIVE_INFINITY : version;
	const rows = kitchens ? [...kitchens.children].sort((a, b) => rank(b.version) - rank(a.version)) : [];

	return (
		<Box w={'100%'} h={'100%'} m={'1px'} border={'0px'}>
			<HStack h={'100%'} gap={'0px'}>
				<Menu isLazy>
					<MenuButton as={RtaIconButton} icon={<GitBranch/>} enabled={rows.length > 0} label="Version history"/>
					<Portal>
						<MenuList maxH="360px" overflowY="auto">
							{rows.map((kitchen) => {
								const isActive = kitchen.id === activeId;
								const label = kitchen.version === null ? `Draft${kitchen.baseVersion ? ` (from v${kitchen.baseVersion})` : ''}` : `Version ${kitchen.version}`;
								return (
									<MenuItem key={kitchen.id} onClick={() => loadVersion(kitchen.version)}>
										<HStack justifyContent="space-between" w="100%">
											<Text fontWeight={isActive ? 'bold' : 'normal'}>{label}</Text>
											{isActive && <Badge colorScheme="blue">active</Badge>}
										</HStack>
									</MenuItem>
								);
							})}
						</MenuList>
					</Portal>
				</Menu>
			</HStack>
		</Box>
	);
};
